import { fetchPlaceholders } from 'scripts/aem.js';
import './author-left-rail.css';

export default async function decorate(block: HTMLElement) {
	const authors = block.children[0];
	if (!authors) return;
	authors.className = 'author-left-rail__authors';

	const authorList = document.createElement('div');
	authorList.className = 'author-left-rail__author-list';

	const totalAuthors = authors.children.length;

	Array.from(authors.children).forEach((author, index) => {
		if (index > 4) {
			author.remove();
			return;
		}

		const imageNameContainer = document.createElement('div');
		imageNameContainer.className = 'author-left-rail__image-name-container';

		const authorImage = author.querySelector('picture');
		const authorLink = author.querySelector('a')?.cloneNode() as HTMLElement;
		if (authorImage) {
			if (authorImage.parentElement?.tagName === 'P') {
				authorImage.parentElement.remove();
			}

			const img = authorImage.querySelector('img');
			if (img) {
				img.alt = img.alt ?? '';
			}

			if (authorLink) {
				authorLink.className = '';
				authorLink.innerHTML = '';
				authorLink.append(authorImage);
			}

			imageNameContainer.append(authorLink ?? authorImage);
		}

		const nameDate = document.createElement('div');
		nameDate.className = 'author-left-rail__name-date';
		imageNameContainer.append(nameDate);

		Array.from(author.children).forEach((rowChild) => {
			const button = rowChild.querySelector('.button');
			if (button) {
				button.classList.remove('button');
				button.parentElement?.classList.remove('button-container');
			}

			nameDate.append(rowChild);
		});

		author.replaceWith(imageNameContainer);
		authorList.append(imageNameContainer);

		const authorLimit = Math.min(totalAuthors, 5);

		if (index < authorLimit - 1) {
			authorList.append(document.createElement('hr'));
		}
	});

	const authorLabel = document.createElement('p');
	authorLabel.className = 'author-left-rail__author-label';
	const placeholders = await fetchPlaceholders();
	authorLabel.innerHTML = `${placeholders.leftRailAuthor || 'Author(s)'}:`;
	authors.append(authorLabel);
	authors.append(authorList);

	const ctaContainer = block.children[1];
	if (ctaContainer) {
		ctaContainer.className = 'author-left-rail__cta';
		const cta = ctaContainer.querySelector('.button');

		if (cta) {
			cta.className = '';

			const ctaButtonContent = document.createElement('div');
			const ctaLabels = document.createElement('div');
			ctaLabels.innerHTML = `<p>${cta.innerHTML}</p>`;
			ctaButtonContent.append(ctaLabels);

			if (cta.parentElement!.nextElementSibling) {
				ctaLabels.append(cta.parentElement!.nextElementSibling);
			}

			const ctaImg = document.createElement('img');
			ctaImg.src = '/icons/arrow-right-black.svg';
			ctaImg.alt = '';
			ctaButtonContent.append(ctaImg);

			cta.innerHTML = '';
			cta.append(ctaButtonContent);
		}
	}
}
